import type { SectionProps } from "../../../components/Questionnaire/Section";
import type { RuleSet } from "../../../components/Questionnaire/validation/form/types";
import type { QuestionnaireState } from "../types";
import { questionnaireInitialState } from "../reducer/initialState";
import { handleSetConfigAction } from "../reducer/actions/setConfigAction";
import { handleSetAction } from "../reducer/actions/setAction/setAction";
import { handleSetValidationsAction } from "../reducer/actions/setValidationsAction";

/**
 * Compute the fully-transformed questionnaire state synchronously.
 *
 * Chains the same three reducer actions that useQuestionnaireInitialization
 * dispatches via useEffect, but runs them as pure function calls so the
 * result can be passed to useHydrateAtoms for SSR-safe hydration.
 *
 * Order matters: config must be applied first because handleSetAction
 * reads config.locale from state.
 */
export const computeInitialQuestionnaireState = (
  sections?: SectionProps[],
  validations?: readonly RuleSet[],
  config: Record<string, unknown> = {},
): QuestionnaireState => {
  let state: QuestionnaireState = questionnaireInitialState;

  if (config && Object.keys(config).length) {
    state = handleSetConfigAction(state, config);
  }

  if (sections) {
    state = handleSetAction(state, sections);
  }

  if (validations && Object.keys(validations).length) {
    state = handleSetValidationsAction(state, validations);
  }

  return state;
};
